import { Box } from "@mui/material";
import React from "react";
import Form from "./Form";
import ExportFourPLData from "./ExportFourPLData";
import { useSelector } from "react-redux";
import Table from "./Table";

export default function FourPL() {
	const state = useSelector((store) => store.analyze);
	const { fourPLDataPrepared, clearAnalyze3PL } = state;

	return (
		<Box>
			<Form />
			{fourPLDataPrepared !== null && clearAnalyze3PL ? <ExportFourPLData /> : null}
			{fourPLDataPrepared !== null && clearAnalyze3PL ? <Table /> : null}
		</Box>
	);
}
